import * as React from 'react';
import { useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";


import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider } from '@mui/material';
import FormControl from '@mui/material/FormControl';


import { SelectTypeInput } from './SelectTypeInput';
import { TextTypeInput } from './TextTypeInput';
import { DocumentFileUpload } from './DocumentFileUpload'
import { govermentIdArray } from '../constant';

export const GovermentIdDialog = ({
    govermentId,
    setGovermentId,
    index,
    isEditing=false


}) => {

    const [open, setOpen] = React.useState(false);
    const [otherFileds, setOtherFields] = useState(false);
    const [filteredGovermentIdArray, setFilteredGovermentIdArray] = useState(govermentIdArray);
    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isValid },
        getValues,
        setValue,
        reset,
        watch,
        trigger,
    } = useForm();


    const onChange = (idType) => {
        if (idType && idType.toLowerCase() === 'other') {
            setOtherFields(true);
        }
        else {
            setOtherFields(false);
        }
        trigger('idNumber')
    }

    const handleClickOpen = () => {
        const govermentIdData = govermentId?.[index];
        const idsToFilterBy = govermentId.filter(item => item.isActive).map(item => item.idName);
       
        const filteredGovermentIdArray = govermentIdArray.filter(item => !idsToFilterBy.includes(item));
        if(isEditing && govermentIdArray.includes(govermentIdData.idName)){
            filteredGovermentIdArray.unshift(govermentIdData.idName)
        }
        setFilteredGovermentIdArray(filteredGovermentIdArray);
                   
        //checking for other type in ID collection as backend dont give flag for isOther
        if(govermentIdData && !govermentIdArray.includes(govermentIdData?.idName)){
            setOtherFields(true);
            govermentIdData.other= govermentIdData.idName;
            govermentIdData.idName = 'Other';
        }
        reset({
            idName: govermentIdData?.idName || '',
            idNumber: govermentIdData?.idNumber || '',
            other: govermentIdData?.other || '',
            uploadedImages: govermentIdData?.uploadedImages || [],
          });
        setOpen(true);
    };

    const handleClose = () => {
        const govermentIdData = govermentId?.[index];
        if(govermentIdData && govermentIdData?.idName.toLowerCase() == 'other'){
            govermentIdData.idName = govermentIdData.other;
        }
        setOpen(false);
        setOtherFields(false);
        reset();
    };

    const handleSubmitForm = (field) => {
        const data = getValues();
        if(data.idName.toLowerCase() === 'other'){
            data.idName = data.other;
        }
        else{
            data.other = '';
        }
        data.isActive = true;
        setOpen(false);
        if(isEditing){
            setGovermentId(govermentId.map((item, i) => i === index ? { ...item, ...data } : item));
        }
        else {
            setGovermentId([...govermentId, data]);
        }
        setOtherFields(false);
        reset();
    };

    return (
        <React.Fragment>
            {
                !isEditing ?(
                    <button className=" flex p-2 border rounded-lg border-blue-500 text-sm text-semibold text-blue-700 gap-1 " onClick={handleClickOpen}>
                    <img src="https://views.medibuddy.in/providerUi/assets/bluePlus.svg" alt="" />
                    <p> Add New</p>
                </button>
                ):
                <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { e.preventDefault(); handleClickOpen() }} style={{ cursor: 'pointer' }} />
            }
         

            <Dialog
                style={{ borderRadius: '16px' }}
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{
                    component: 'form',
                    style: { borderRadius: '1rem' },
                    onSubmit: (event) => {
                        event.preventDefault();
                        handleClose();
                    },
                }}
            >
                <DialogTitle>
                    <div className="text-xl font-semibold text-left text-[#47566A]">
                    Government ID
                    </div>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div className="flex flex-col " style={{ gap: '1.5rem' }}>
                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                Government ID
                                    <p className=' text-mb-red' >*</p>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.idName}>
                                        <SelectTypeInput
                                            name={'idName'}
                                            placeholder={'Select a Government ID'}
                                            onChange={onChange}
                                            control={control}
                                            width={'31.6rem'}
                                            height={'2.75rem'}
                                            defaultValue=''
                                            rules={{ required: "Mandatory information" }}
                                            options={filteredGovermentIdArray.map((item) => ({ value: item, title: item }))}
                                            errors={errors}
                                        />
                                    </FormControl>
                                </div>
                            </div>

                            {
                                otherFileds && <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Other
                                    <p className=' text-mb-red' >*</p>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.other}>
                                    <TextTypeInput
                                    name={'other'}
                                    label={''}
                                    placeholder="Enter Government Id"
                                    control={control}
                                    defaultValue=""
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory information",
                                        pattern: {
                                          value: /^[a-zA-Z0-9]*$/,
                                          message: "Invalid Input. Only (A-Z) and (0-9) are allowed."   
                                        },
                                        maxLength: {
                                          value: 25,
                                          message: "Maximum 12 characters allowed"
                                        }
                                      }} 
                                    errors={errors}
                                />
                                    </FormControl>
                                </div>
                            </div>

                            }

                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    ID Number
                                    <p className=' text-mb-red' >*</p>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.idNumber}>
                                    <TextTypeInput
                                    name={'idNumber'}
                                    label={''}
                                    placeholder="Enter Government ID Number"
                                    control={control}
                                    defaultValue=""
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory information",
                                        pattern: {
                                          value: /^[a-zA-Z0-9]*$/,
                                          message: "Invalid Input. Only (A-Z) and (0-9) are allowed."   
                                        },
                                       validate: (val) => {
                                        const idName = watch('idName');
                                        if(idName){
                                            switch (idName) {
                                                case "Aadhar Card":
                                                  return /^[0-9]{12}$/.test(val) || "Invalid Aadhar Card Number";
                                                case "Pan Card":
                                                  return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(val) || "Invalid Pan Card Number";
                                                case "Passport":
                                                  return /^[A-Z0-9]{8,9}$/.test(val) || "Invalid Passport Number";
                                                case "Driver's License":
                                                  return /^[A-Z0-9]{15}$/.test(val) || "Invalid Driver's License Number";
                                                case "Other":
                                                  return val.length >= 1;
                                                default:
                                                  return "Invalid ID type.";
                                              }
                                        }

                                       }
                                      }} 
                                    errors={errors}
                                />
                                    </FormControl>
                                </div>
                            </div>

                            <div className=" flex flex-col gap-1">
                                <div className="flex  text-base font-normal text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Upload ID Image
                                </div>

                                <div className="flex flex-row basis-3 gap-2">
                                    <Controller
                                        name={'uploadedImages'}
                                        control={control}
                                        render={({ field }) => {
                                            return (
                                                <DocumentFileUpload field={field} setValue={setValue} name={'uploadedImages'} />
                                            )
                                        }} />

                                </div>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <Divider variant='fullWidth' />

                <DialogActions>
                    <div className="flex gap-2 px-3 py-2">
                        <Button className=' border rounded-lg  text-sm text-semibold p-1  gap-1 ' variant='outlined' onClick={handleClose} style={{ color: '#252D38', borderColor: '#DBE0E6', borderRadius: '0.5rem' }}>Cancel</Button>
                        <button
                            className={`${isDirty ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                            style={{ color: isDirty ? 'white' : '#A4B0C0' }}
                            onClick={handleSubmit(handleSubmitForm)}                            >
                            Save Details
                        </button>                    
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}